import { Component, input, output } from '@angular/core';
import { IconComponent } from '@components/icon/icon.component';
import { SearchSuggestion } from '@interfaces/search-result.interface';

@Component({
  selector: 'app-search-empty-state',
  imports: [IconComponent],
  templateUrl: './search-empty-state.component.html',
  styleUrl: './search-empty-state.component.scss'
})
export class SearchEmptyStateComponent {
  public readonly recent = input<string[]>([]);
  public readonly suggestions = input<SearchSuggestion[]>([]);
  public readonly recentSelected = output<string>();
  public readonly suggestionSelected = output<SearchSuggestion>();
}
